import { FC, useEffect } from 'react'
import { Box, ColumnLayout, Container, Header, SpaceBetween } from '@cloudscape-design/components'

import { useGenericTagsManagementFormStore } from '../../../../stores/tags/genericTagsManagementFormStore'
import { keysToLabel } from '../../../../helper/toCamelCase'

function formatTagCell(val: unknown): string {
	if (val == null || val === '') return '—'
	if (typeof val === 'object' && val !== null && ('value' in val || 'label' in val)) {
		const o = val as { value?: string; label?: string }
		return o.label ?? o.value ?? '—'
	}
	return String(val)
}

const StgTagsReadOnly: FC = () => {
	const {
		formValues,
		actions: { setFormValidity }
	} = useGenericTagsManagementFormStore()

	const tagKeys = Object.keys(formValues)

	useEffect(() => {
		setFormValidity(true)
	}, [setFormValidity])

	return (
		<SpaceBetween direction="vertical" size="l">
			<Container header={<Header variant="h3">Tags (from approved request)</Header>}>
				<Box variant="p" color="text-body-secondary" margin={{ bottom: 'm' }}>
					These values are inherited and cannot be changed for STG onboarding.
				</Box>
				<ColumnLayout columns={2} variant="text-grid">
					{tagKeys.map((tagkey) => (
						<div key={tagkey}>
							<Box variant="awsui-key-label">
								{keysToLabel(tagkey) === 'W B S Code' ? 'WBS Code' : keysToLabel(tagkey)}
							</Box>
							{formatTagCell(formValues[tagkey])}
						</div>
					))}
				</ColumnLayout>
			</Container>
		</SpaceBetween>
	)
}

export default StgTagsReadOnly
